import { useEffect, useState } from 'react';

import { SpinnerIcon } from '../icons/SpinnerIcon';
import type { MapBounds } from './interfaces';

interface Props {
    bounds: MapBounds;
    boundsChanged: boolean;
    loading: boolean;
    onUpdateBoundsClick?: (bounds: MapBounds) => void;
    setBoundsChanged: (changed: boolean) => void;
    canUpdateBoundsOnClick?: (bounds: MapBounds) => Promise<boolean>;
}

export const UpdateBoundsButton = ({
    bounds,
    boundsChanged,
    loading,
    onUpdateBoundsClick,
    setBoundsChanged,
    canUpdateBoundsOnClick = () => Promise.resolve(true),
}: Props) => {
    const [boundsSearchable, setBoundsSearchable] = useState(false);
    const [waitingForData, setWaitingForData] = useState(false);

    useEffect(() => {
        async function fetchApi() {
            setBoundsSearchable(false);
            setWaitingForData(true);
            setBoundsSearchable(await canUpdateBoundsOnClick(bounds));
            setWaitingForData(false);
        }

        fetchApi();
    }, [bounds.sw[0], bounds.sw[1], bounds.ne[0], bounds.ne[1]]);
    if (onUpdateBoundsClick && bounds && boundsChanged && !loading) {
        const onClick = () => {
            onUpdateBoundsClick(bounds);
            setBoundsChanged(false);
        };
        return (
            <div className="mapboxgl-ctrl mapboxgl-custom-ctrl custom-ctrl-top">
                <button
                    type="button"
                    className="button button--utility u-t4 u-pv0 u-size1of1 update-bounds-button"
                    disabled={!boundsSearchable}
                    onClick={onClick}>
                    {waitingForData ? (
                        <>
                            Kalkulerer søkeområde
                            <SpinnerIcon className="spinner u-ml8" />
                        </>
                    ) : boundsSearchable ? (
                        'Gjenta søk i dette området'
                    ) : (
                        'Zoom inn for å endre søkeområde'
                    )}
                </button>
            </div>
        );
    }
    return null;
};
